import WixSDK from 'shared/utils/wix-sdk';
import { getScreenSizeByUserAgent, isLandscape } from 'shared/utils/device/screen';


export function isMobileWidgetVisibleInViewPort() {
  return WixSDK.getBoundingRectAndOffsets()
    .then(data => {
      const { rect: { top, bottom } } = data;

      const { width, height } = getScreenSizeByUserAgent();
      const screenHeight = isLandscape() ? width : height;

      return (top <= 0 && bottom >= screenHeight) || (top >= 0 && bottom <= screenHeight);
    });
}



// WEBPACK FOOTER //
// ./src/widget/utils/widget.js